import { render, staticRenderFns } from "./video.vue?vue&type=template&id=1f22d07a&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=1f22d07a&prod&lang=less"
import style1 from "./video.vue?vue&type=style&index=1&id=1f22d07a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22d07a",
  null
  
)

export default component.exports